/**
 * Tenant Resolution Utility — Path-based routing
 * 
 * Routes: /{tenant_slug}/dashboard, /{tenant_slug}/login, /{tenant_slug}/parent
 * 
 * Also supports legacy ?tenant=slug query param and subdomain for backward compat.
 */

const PLATFORM_PATHS = ['admin', 'saas-admin', 'billing', 'preview', 'login', 'forgot-password', 'reset-password', 'accept-invite'];

/**
 * Extract tenant slug from URL path (first segment).
 * Returns null if it's a platform route.
 */
export function resolveTenantFromPath(pathname) {
  if (!pathname || pathname === '/') return null;
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) return null;
  const first = segments[0].toLowerCase();
  if (PLATFORM_PATHS.includes(first)) return null;
  return first;
}

/**
 * Legacy: resolve from hostname subdomain (still works if subdomains are configured).
 */
export function resolveTenantFromHostname(hostname) {
  if (!hostname) return null;
  if (hostname === 'localhost' || /^(\d+\.){3}\d+$/.test(hostname.split(':')[0])) return null;
  if (hostname.includes('emergentagent.com')) return null;

  const host = hostname.split(':')[0];
  const parts = host.split('.');
  if (parts.length < 3) return null;

  const sub = parts[0].toLowerCase();
  const platformSubs = ['app', 'www', 'admin', 'api', 'mail', 'portal'];
  if (platformSubs.includes(sub) || !sub) return null;
  return sub;
}

/**
 * Get tenant slug — priority: path > subdomain > query param
 */
export function getTenantSlug(pathname, searchParams) {
  return resolveTenantFromPath(pathname)
    || resolveTenantFromHostname(window.location.hostname)
    || searchParams?.get('tenant')
    || '';
}

/**
 * Build a tenant-scoped URL.  /{slug}/path
 */
export function tenantUrl(path, slug) {
  if (!slug) return path;
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `/${slug}${clean}`;
}
